<script setup>
import { defineEmits, defineProps } from 'vue'
import BaseCard from "@/pages/UserProfile/integrations/BaseCard.vue";

defineProps({
    integrations: Array
});

const emit = defineEmits(['open-integrations-details']);
</script>

<template>
    <BaseCard>
        <template #header>
            <h3 class="font-medium text-gray-900 text-base">Интеграции</h3>
            <button
                type="button"
                class="text-blue-600 text-sm hover:underline font-medium"
                @click="emit('open-integrations-details')"
            >
                Подробнее
            </button>
        </template>
        <div class="space-y-4">
            <div v-for="integration in integrations" :key="integration.id" class="flex justify-between items-center py-2">
                <div class="flex items-center gap-3">
                    <div class="w-8 h-8 bg-gray-100 rounded flex items-center justify-center text-gray-500">
                        <component :is="integration.icon" class="size-6" />
                    </div>
                    <div class="flex flex-col">
                        <p class="text-sm font-medium text-gray-800">{{ integration.name }}</p>
                        <span
                            class="text-xs"
                            :class="{
                                'text-green-600': integration.status === 'Подключено',
                                'text-red-600': integration.status === 'Ошибка в подключении',
                                'text-amber-600': integration.status === 'Требует внимания'
                            }"
                        >
                            {{ integration.status }}
                        </span>
                    </div>
                </div>
                <span class="text-gray-300 text-xs">›</span>
            </div>
        </div>
    </BaseCard>
</template>